import { createBrowserRouter, ScrollRestoration } from "react-router-dom";

import MainHome from "./pages/MainHome";
import MainPrivacyPolicy from "./pages/MainPrivacyPolicy";
import MainAboutUs from "./pages/MainAboutUs";
import Home from "./pages/Home";
import PageNotFound from "./pages/404";
import MainCareers from "./pages/MainCareers";
import MainForAgent from "./pages/MainForAgent";
import MainForBuyers from "./pages/MainForBuyer";
import MainTermsConditions from "./pages/MainTermsConditions";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollRestoration />
        <Home />
      </>
    ),
    children: [
      { index: true, element: <MainHome /> },
      { path: "about-us", element: <MainAboutUs /> },
      { path: "careers", element: <MainCareers /> },
      { path: "agent-domain", element: <MainForAgent /> },
      { path: "buyer-query", element: <MainForBuyers /> },
      { path: "privacy-policy", element: <MainPrivacyPolicy /> },
      { path: "terms-conditions", element: <MainTermsConditions /> },
    ],
  },
  {
    path: "*", // <- now outside Home layout
    element: <PageNotFound />, // <- renders standalone
  },
]);

export default router;
